import { render, staticRenderFns } from "./SpecifyBatch.vue?vue&type=template&id=3af19c52&scoped=true&"
import script from "./SpecifyBatch.vue?vue&type=script&lang=js&"
export * from "./SpecifyBatch.vue?vue&type=script&lang=js&"
import style0 from "./SpecifyBatch.vue?vue&type=style&index=0&id=3af19c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af19c52",
  null
  
)

export default component.exports